<div class="layout-container" [ngClass]="containerClass">
  <app-topbar></app-topbar>
  <app-sidebar></app-sidebar>
  <div class="layout-content-wrapper">
    <div class="layout-content" (scroll)="onScroll($event)">
      <div class="layout-content-inner">
        <div class="flex justify-content-between">
        </div>
        <router-outlet></router-outlet>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</div>

